import axios, {AxiosInstance} from 'axios'
import {errorHandler, successHandler} from "../index";
import {LocalStorageEnum} from "../enum/localStorage";
import {LanguageEnum} from "../enum/language";

const axiosInstanceV1: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API + '/api/v1'
})

const axiosInstanceToken: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API + '/api/v1'
})

const axiosInstanceTokenV2: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API + '/api/v2'
})

const axiosInstanceRegisterToken: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API + '/api/v1'
})

const axiosInstanceRegisterTokenV2: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API + '/api/v2'
})

const axiosInstanceCaptchaToken: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API + '/api/v1'
})

const axiosInstanceNoToken: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API + '/api/v1'
})

const getLang = () => {
    switch (localStorage.getItem(LocalStorageEnum.lang)) {
        case LanguageEnum.Ru :
            return 'ru-RU'
        case LanguageEnum.En :
            return 'en-US'
        default:
            return 'ru-RU'
    }
}

axiosInstanceNoToken.interceptors.request.use(function (config) {
        if (config.headers) {
            config.headers["Accept-Language"] = getLang();
        }
        return config;
    }
);

axiosInstanceRegisterToken.interceptors.request.use(function (config) {
        const token = localStorage.getItem(LocalStorageEnum.registerToken);
        config.headers = {}
        config.headers["Authorization"] = "Bearer " + token
        config.headers["Accept-Language"] = getLang();
        return config;
    }
);

axiosInstanceRegisterTokenV2.interceptors.request.use(function (config) {
        const token = localStorage.getItem(LocalStorageEnum.registerToken);
        config.headers = {}
        config.headers["Authorization"] = "Bearer " + token
        config.headers["Accept-Language"] = getLang();
        return config;
    }
);

axiosInstanceToken.interceptors.request.use(function (config) {
        const token = localStorage.getItem(LocalStorageEnum.access_token);
        config.headers = {}
        config.headers["Authorization"] = "Bearer " + token
        config.headers["Accept-Language"] = getLang();
        return config;
    }
);

axiosInstanceTokenV2.interceptors.request.use(function (config) {
        const token = localStorage.getItem(LocalStorageEnum.access_token);
        config.headers = {}
        config.headers["Authorization"] = "Bearer " + token
        config.headers["Accept-Language"] = getLang();
        return config;
    }
);

axiosInstanceV1.interceptors.request.use(function (config) {
        const token = localStorage.getItem(LocalStorageEnum.access_token);
        config.headers = {}
        config.headers["Authorization"] = "Bearer " + token
        config.headers["Accept-Language"] = getLang();
        return config;
    }
);

axiosInstanceCaptchaToken.interceptors.request.use(function (config) {
        const token = localStorage.getItem(LocalStorageEnum.access_token);
        const captcha = localStorage.getItem(LocalStorageEnum.captcha);
        config.headers = {}
        config.headers["Authorization"] = "Bearer " + token
        config.headers["Accept-Language"] = getLang();
        if (captcha) config.headers["G-Recaptcha-Response"] = captcha
        return config;
    }
);

axiosInstanceV1.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

axiosInstanceToken.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

axiosInstanceTokenV2.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

axiosInstanceRegisterToken.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

axiosInstanceCaptchaToken.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);
axiosInstanceNoToken.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);
axiosInstanceRegisterTokenV2.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);


export {
    axiosInstanceV1,
    axiosInstanceToken,
    axiosInstanceTokenV2,
    axiosInstanceRegisterToken,
    axiosInstanceCaptchaToken,
    axiosInstanceNoToken,
    axiosInstanceRegisterTokenV2,
}
